module.exports = __webpack_public_path__ + "static/media/room-1.6c9857e9.jpeg";